import { HiringCompanyApprovalStatus } from "@utils/constants";

export enum EnumStaffRequestApproval {
    APPROVE=1,
    REJECT
}

export interface IUpdateStaffRequestQueryParams {
    userId: string,
    status: EnumStaffRequestApproval
}